import { 
  GET_WALKS
} from '../constants/index';
import {
  WalkState,
  walkActions
} from '../types/walkTypes'

const initialState: WalkState = {
  walks: [],
  publicWalks: []
}

const walkReducer = (state = initialState, action: walkActions) => {
  const payload = action.payload

  switch(action.type){
    case GET_WALKS:    
      const publicWalks = payload.walks.filter((walk: any) => {
        if(walk.teamId === null && walk.booked === 0 && new Date(walk.start) > new Date()) {
          return walk
        } 
        return null
      })

      return {
        ...state,
        walks: payload.walks,
        publicWalks: publicWalks
      }

    default: 
      return state
  }
}

export default walkReducer;